import React, {
  useEffect,
  useState,
  useCallback,
  useRef,
  useLayoutEffect,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useContext } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Col,
  Row,
  Card,
  CardBody,
} from "reactstrap";
import Select from "react-select";
import Slider from "react-slick";
import { fetchSkillsRequest } from "../../../redux/mandatorySkills/actions";
import { showToast } from "../../Common/Toast";
import { AVATAR, SYSTEM_PREFIX, customOptionsStyle } from "../../../Constant";
import Spinner from "../../Common/Spinner";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetchCompanyProfile } from "../../../redux/recruiter/company_profile/actions";
import { fetchJobseekerDataRequest } from "../../../redux/jobseeker/fetch_Jobseeker_data/actions";
import { roleOptions, JOBSEEKER_PROFILE_IMAGE } from "../../../Constant";
import { showStyledCoins } from "../../Common/CommonFunction";
import {
  capitalize,
  formatWebsite,
  capitalizeEachWord,
  idToBase64,
} from "../../Common/CommonFunction";
import { TbBuilding } from "react-icons/tb";
import { FaGraduationCap } from "react-icons/fa6";
import html2canvas from "html2canvas";
import { saveAs } from "file-saver";
import { IoIosArrowBack } from "react-icons/io";
import { IoIosArrowForward } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaGlobe } from "react-icons/fa";
import { useParams } from "react-router";
import { fetchLocationsRequest } from "../../../redux/location/actions";
import { TiLocation } from "react-icons/ti";
import style1 from "./customStyles/style1.css";
import style2 from "./customStyles/style2.css";
import style3 from "./customStyles/style3.css";
import style4 from "./customStyles/style4.css";
import style5 from "./customStyles/style5.css";
import style6 from "./customStyles/style6.css";
import style7 from "./customStyles/style7.css";
import style8 from "./customStyles/style8.css";
import style9 from "./customStyles/style9.css";
import style10 from "./customStyles/style10.css";
import style11 from "./customStyles/style11.css";
import style12 from "./customStyles/style12.css";
import style13 from "./customStyles/style13.css";
import style14 from "./customStyles/style14.css";
import style15 from "./customStyles/style15.css";
import style16 from "./customStyles/style16.css";
import { includes } from "lodash";
import { ResponsiveText } from "react-responsive-text";
import {
  unlockLinkedInBannerRequest,
  resetUnlockLinkedInBannerMessage,
} from "../../../redux/unlock_linkedin_banner/actions";
import { fetchRewardsPointsRequest } from "../../../redux/fetch_rewards_points/actions";
import { AuthContext } from "../../../Auth/AuthContext";
import { getLinkedInBannerRequest } from "../../../redux/get_linkedin_banner/actions";
// Character Thresholds Configuration
const CHARACTER_THRESHOLDS = {
  template1: {
    name: [
      // { threshold: 150, reduction: 30 }, // Extreme length handling
      // { threshold: 100, reduction: 20 }, // Very long text
      { threshold: 72, reduction: 15 }, // Long text
    ],
    role: [
      // { threshold: 35, reduction: 7 },
      // { threshold: 25, reduction: 5 },
      { threshold: 20, reduction: 3 },
    ],
  },
  template2: {

    name: [{ threshold: 35, reduction: 18 }],
    role: [
      // { threshold: 35, reduction: 7 },
      // { threshold: 25, reduction: 5 },
      { threshold: 20, reduction: 3 },
    ],
  },
  template3: {
    name: [
      { threshold: 56, reduction: 10 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 25, reduction: 4 },
    ],
  },
  template4: {
    name: [
      { threshold: 33, reduction: 20 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template5: {
    name: [
      { threshold: 39, reduction: 15 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template6: {
    name: [
      { threshold: 58, reduction: 10 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template7: {
    name: [
      { threshold: 60, reduction: 10 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template8: {
    name: [
      { threshold: 38, reduction: 10 }, // Long text
    ],
    role: [
      { threshold: 40, reduction: 8 },
      { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template9: {
    name: [
      { threshold: 39, reduction: 9 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template10: {
    name: [
      { threshold: 21, reduction: 5 }, // Long text
      { threshold: 30, reduction: 10 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template11: {
    name: [
      { threshold: 39, reduction: 9 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template12: {
    name: [
      { threshold: 21, reduction: 7 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template13: {
    name: [
      { threshold: 22, reduction: 12 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 5 },
    ],
  },
  template14: {
    name: [
      { threshold: 33, reduction: 10 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template15: {
    name: [
      { threshold: 23, reduction: 7 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 4 },
    ],
  },
  template16: {
    name: [
      { threshold: 22, reduction: 8 }, // Long text
    ],
    role: [
      // { threshold: 40, reduction: 8 },
      // { threshold: 30, reduction: 6 },
      { threshold: 15, reduction: 2 },
    ],
  },
};
const BannerScaleWrapper = ({ children, id }) => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    const parent = el.parentElement;
    if (!parent) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const width = entry.contentRect.width || parent.getBoundingClientRect().width;
        if (width > 0) {
          setScale(Math.min(width / 1100, 1));
        }
      }
    });

    resizeObserver.observe(parent);

    const initialWidth = parent.getBoundingClientRect().width;
    if (initialWidth > 0) {
      setScale(Math.min(initialWidth / 1100, 1));
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      id={id}
      ref={containerRef}
      style={{
        zoom: scale,
        width: "1100px",
        position: "relative",
      }}
    >
      {children}
    </div>
  );
};

const BannerModal = (props) => {
  const dispatch = useDispatch();
  const { triggerTotalPoints } = useContext(AuthContext);
  const savedState = localStorage.getItem("jobseekerBannerProfile");
  const parsedState = JSON.parse(savedState);
  const componentRef = useRef(null);
  const [locationOptions, setLocationOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false); // Step 1: Add loading state
  const [profile, setProfile] = useState({
    photo: AVATAR,
    name: "",
    email: "",
    phone: "",
    resume_headline: "",
    education: [],
    jobseeker_preferred_job_title: "",

    organization: [],
    skills: [],
    quotes: parsedState && parsedState.quotes ? parsedState.quotes : "",
    locations: [],
    includeEmail: false,
    includePhone: false,
    includeName: false,
    includeRole: false,
  });
  console.log("profile444", profile);
  const [error, setError] = useState("");
  const [currentIndex, setCurrentIndex] = useState(props.index);

  console.log("currentIndex", currentIndex);
  const [isBannerUnlocked, setIsBannerUnlocked] = useState(false);
  console.log("isBannerUnlocked", isBannerUnlocked);
  const getLinkedinBannerReducerData = useSelector(
    (state) => state.getLinkedinBannerReducer
  );
  const allBanners = getLinkedinBannerReducerData.data;

  const fetchJobseekerDataReducerData = useSelector(
    (state) => state.fetchJobseekerDataReducer
  );

  // Effect to update isBannerUnlocked when currentIndex changes
  useEffect(() => {
    if (allBanners[currentIndex]) {
      console.log("current", allBanners[currentIndex]);
      setIsBannerUnlocked(allBanners[currentIndex].is_purchased);
      // setIsBannerUnlocked(allBanners[currentIndex].banner_id);
    }
  }, [currentIndex, allBanners]);

  useEffect(() => {
    dispatch(fetchJobseekerDataRequest());
  }, [dispatch]);

  useEffect(() => {
    if (
      !fetchJobseekerDataReducerData.isLoading &&
      fetchJobseekerDataReducerData.data &&
      fetchJobseekerDataReducerData.status === true
    ) {
      const data = fetchJobseekerDataReducerData.data.data || {};
      const candidateName =
        data.jobseeker_full_name ||
        data.full_name ||
        data.name ||
        (data.jobseeker_first_name ? `${data.jobseeker_first_name} ${data.jobseeker_last_name || ""}`.trim() : "") ||
        "Candidate";

      if (savedState) {
        const updatedProfile = {
          photo: data.jobseeker_photo
            ? `${data.jobseeker_photo}?t=${Date.now()}`
            : AVATAR,
          name: candidateName,
          jobseeker_preferred_job_title:
            data.jobseeker_preferred_job_title || "",
          email: data.jobseeker_email1 || "",
          phone: data.jobseeker_phone1 || "",
          resume_headline: data.resume_headline || "",
          organization: Array.isArray(data.work_experience)
            ? data.work_experience.map((work) => work.organization)
            : [],
          education: Array.isArray(data.education)
            ? data.education.filter((edu) => edu.type === "college")
            : [],
          skills: parsedState.skills || [],
          includeEmail: parsedState.includeEmail,
          includePhone: parsedState.includePhone,
          includeName: parsedState.includeName,
          includeRole: parsedState.includeRole,
          locations: parsedState.locations,
        };
        setProfile((prevProfile) => ({
          ...prevProfile,
          ...updatedProfile,
        }));
      } else {
        const updatedProfile = {
          photo: data.jobseeker_photo
            ? `${data.jobseeker_photo}?t=${Date.now()}`
            : AVATAR,
          name: candidateName,
          email: data.jobseeker_email1 || "",
          phone: data.jobseeker_phone1 || "",
          jobseeker_preferred_job_title:
            data.jobseeker_preferred_job_title || "",
          resume_headline: data.resume_headline || "",
          organization: Array.isArray(data.work_experience)
            ? data.work_experience.map((work) => work.organization)
            : [],
          education: Array.isArray(data.education)
            ? data.education.filter((edu) => edu.type === "college")
            : [],
          skills:
            data.primary_skill?.slice(
              0,
              allBanners[currentIndex]?.skills_allowed
            ) || "",
          locations:
            data.jobseeker_preferred_location?.slice(
              0,
              allBanners[currentIndex]?.locations_allowed
            ) || "",
        };
        setProfile((prevProfile) => ({
          ...prevProfile,
          ...updatedProfile,
        }));
      }
    }
  }, [
    fetchJobseekerDataReducerData.isLoading,
    fetchJobseekerDataReducerData.data,
    fetchJobseekerDataReducerData.status,
    currentIndex,
  ]);

  useEffect(() => {
    // Update the quotes when the slide (currentIndex) changes
    if (!profile.quotes) {
      setProfile((prevProfile) => ({
        ...prevProfile,
        quotes: allBanners[currentIndex].default_quotes || "", // Set the quotes from the banner or an empty string if not available
      }));
    }
  }, [currentIndex, allBanners]);

  console.log("allBanners555", allBanners);
  const [mandatorySkillsOptions, setMandatorySkillsOptions] = useState([]);

  //read industry type data from store
  let mandatorySkillsReducerData = useSelector(
    (state) => state.mandatorySkillsReducer
  );
  // console.log(industryTypeReducerData.data);
  let mandatorySkillsData = mandatorySkillsReducerData.data.data;

  useEffect(() => {
    mandatorySkillsData = mandatorySkillsData || [];
    setMandatorySkillsOptions(mandatorySkillsData);
  }, [mandatorySkillsData]);

  const handlemandatorySkillsFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchSkillsRequest(keyword, "MANDATORY"));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  // Callback to handle location input change
  const handleMandatorySkillsInputChange = useCallback((inputValue) => {
    // Fetch data based on the inputValue (keyword)
    const fetchData = async () => {
      try {
        dispatch(fetchSkillsRequest(inputValue, "MANDATORY"));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location input changes
    fetchData();
  }, []);
  const skillsContainerRef = useRef(null);
  // const ensureFullOverflow = () => {
  //   const container = skillsContainerRef.current; // Get the container reference
  //   if (!container) {
  //     console.error("Container not found!");
  //     return;
  //   }
  //   const ulElement = container.querySelector("ul");
  //   const children = Array.from(ulElement.children); // Get the <li> elements
  //   const containerWidth = container.clientWidth; // Get the container width
  //   const containerHeight = container.clientHeight; // Get the container height

  //   let totalWidth = 0;
  //   let totalHeight = 0;
  //   let lastVisibleChildIndex = -1; // Track the last visible child index

  //   console.log(
  //     `Container width: ${containerWidth}, height: ${containerHeight}`
  //   );

  //   // Reset all children styles to ensure we can measure their dimensions
  //   children.forEach((child) => {
  //     child.style.display = ""; // Reset display to ensure we can measure width and height
  //   });

  //   // Trigger reflow
  //   void container.offsetWidth;

  //   // Iterate over children to calculate visibility
  //   for (let i = 0; i < children.length; i++) {
  //     const child = children[i];
  //     const childWidth = child.offsetWidth; // Get the width of the child
  //     const childHeight = child.offsetHeight; // Get the height of the child

  //     totalWidth += childWidth;
  //     totalHeight += childHeight;

  //     console.log(
  //       `Child ${i} width: ${childWidth}, height: ${childHeight}, Total Width: ${totalWidth}, Total Height: ${totalHeight}, Container Width: ${containerWidth}, Container Height: ${containerHeight}`
  //     );

  //     // Check for horizontal overflow
  //     if (totalWidth > containerWidth) {
  //       console.log(`Child ${i} causes horizontal overflow, hiding it.`);
  //       child.style.display = "none"; // Hide the child
  //     } else {
  //       lastVisibleChildIndex = i; // Update the last visible index
  //     }

  //     // Check for vertical overflow
  //     if (totalHeight > containerHeight) {
  //       console.log(`Child ${i} causes vertical overflow, hiding it.`);
  //       child.style.display = "none"; // Hide the child
  //     } else {
  //       lastVisibleChildIndex = i; // Update the last visible index
  //     }
  //   }

  //   console.log(`Last visible child index: ${lastVisibleChildIndex}`);

  //   // Restore visible children to full visibility
  //   for (let i = 0; i <= lastVisibleChildIndex; i++) {
  //     const child = children[i];
  //     child.style.display = ""; // Reset display to show the child
  //   }

  //   // If no children are visible, ensure at least one is shown
  //   if (lastVisibleChildIndex === -1 && children.length > 0) {
  //     const firstChild = children[0];
  //     firstChild.style.display = ""; // Show the first child
  //   }
  // };

  const ensureFullOverflow = () => {
    const container = skillsContainerRef.current; // Get the container reference
    if (!container) {
      console.error("Container not found!");
      return;
    }
    const ulElement = container.querySelector("ul");
    const children = Array.from(ulElement.children); // Get the <li> elements
    const containerWidth = container.clientWidth; // Get the container width
    const containerHeight = container.clientHeight; // Get the container height

    let totalWidth = 0;
    let totalHeight = 0;
    let lastVisibleChildIndex = -1; // Track the last visible child index

    console.log(
      `Container width: ${containerWidth}, height: ${containerHeight}`
    );

    // Reset all children styles to ensure we can measure their dimensions
    children.forEach((child) => {
      child.style.display = ""; // Reset display to ensure we can measure width and height
    });

    // Trigger reflow
    void container.offsetWidth;

    // Iterate over children to calculate visibility
    for (let i = 0; i < children.length; i++) {
      const child = children[i];
      const childWidth = child.offsetWidth; // Get the width of the child
      const childHeight = child.offsetHeight; // Get the height of the child

      // Add margin-bottom of 5px to the total height
      const marginBottom = 5;
      totalWidth += childWidth;
      totalHeight += childHeight + marginBottom; // Include margin in total height

      console.log(
        `Child ${i} width: ${childWidth}, height: ${childHeight}, Total Width: ${totalWidth}, Total Height: ${totalHeight}, Container Width: ${containerWidth}, Container Height: ${containerHeight}`
      );

      // Check for horizontal overflow
      if (totalWidth > containerWidth) {
        console.log(`Child ${i} causes horizontal overflow, hiding it.`);
        child.style.display = "none"; // Hide the child
      } else {
        lastVisibleChildIndex = i; // Update the last visible index
      }

      // Check for vertical overflow
      if (totalHeight > containerHeight) {
        console.log(`Child ${i} causes vertical overflow, hiding it.`);
        child.style.display = "none"; // Hide the child
      } else {
        lastVisibleChildIndex = i; // Update the last visible index
      }
    }

    console.log(`Last visible child index: ${lastVisibleChildIndex}`);

    // Restore visible children to full visibility
    for (let i = 0; i <= lastVisibleChildIndex; i++) {
      const child = children[i];
      child.style.display = ""; // Reset display to show the child
    }

    // If no children are visible, ensure at least one is shown
    if (lastVisibleChildIndex === -1 && children.length > 0) {
      const firstChild = children[0];
      firstChild.style.display = ""; // Show the first child
    }
  };

  // Call on load and resize
  useEffect(() => {
    // Use setTimeout to ensure the DOM is fully rendered
    const timeoutId = setTimeout(() => {
      ensureFullOverflow(); // Initial call to set visibility
    }, 0);

    window.addEventListener("resize", ensureFullOverflow);

    // Cleanup event listeners on unmount
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", ensureFullOverflow);
    };
  }, []);

  // Use useEffect to call ensureFullOverflow when profile changes
  useEffect(() => {
    ensureFullOverflow();
  }, [profile]);

  const handleMandatorySkillsChange = (selectedOptions) => {
    const updatedErrors = { ...errors, skills: "" };
    setErrors(updatedErrors);
    setProfile((prevProfile) => ({
      ...prevProfile,
      skills: selectedOptions,
    }));
    ensureFullOverflow();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: checked,
    }));
  };

  let locationReducerData = useSelector((state) => state.locationReducer);
  let locationData = locationReducerData.data.data;

  useEffect(() => {
    locationData = locationData || [];
    setLocationOptions(locationData);
  }, [locationData]);

  const handleLocationFocus = () => {
    // This function will be called when the location dropdown is focused
    // You can trigger your API call here
    const fetchData = async () => {
      try {
        const keyword = ""; // Set your keyword value here
        dispatch(fetchLocationsRequest(keyword));
      } catch (error) {
        console.error(error);
      }
    };

    // Call the fetchData function when the location dropdown is focused
    fetchData();
  };

  // Callback to handle location input change
  const handleLocationInputChange = useCallback((inputValue) => {
    // Fetch data based on the inputValue (keyword)
    const fetchData = async () => {
      try {
        dispatch(fetchLocationsRequest(inputValue));
      } catch (error) {
        // Handle any errors if necessary
      }
    };

    // Call the fetchData function when the location input changes
    fetchData();
  }, []);

  // Callback to handle location select change
  const handleLocationsChange = (selectedOptions) => {
    const updatedErrors = { ...errors, locations: "" };
    setErrors(updatedErrors);
    setProfile((prevProfile) => ({
      ...prevProfile,
      locations: selectedOptions,
    }));
  };

  const validate = () => {
    const errors = {};
    let isValid = true;
    // if (allBanners[currentIndex].skills_allowed != 0) {
    //   if (profile.skills.length > allBanners[currentIndex].skills_allowed) {
    //     errors.skills = `You can only select up to ${allBanners[currentIndex].skills_allowed} skills.`;
    //     isValid = false;
    //   }
    // }

    // if (allBanners[currentIndex].locations_allowed != 0) {
    //   if (
    //     profile.locations.length > allBanners[currentIndex].locations_allowed
    //   ) {
    //     errors.locations = `You can only select up to ${allBanners[currentIndex].locations_allowed} locations.`;
    //     isValid = false;
    //   }
    // }

    setErrors(errors);
    return isValid;
  };

  // Effect to save profile state to local storage whenever it changes
  useEffect(() => {
    localStorage.setItem(
      "jobseekerBannerProfile",
      JSON.stringify({
        includeName: profile.includeName,
        includeRole: profile.includeRole,
        includeEmail: profile.includeEmail,
        includePhone: profile.includePhone,
        includeWebsite: profile.includeWebsite,
        skills: profile.skills,
        locations: profile.locations,
        quotes: profile.quotes,
      })
    );
  }, [profile]);

  const componentPreRef = useRef(null);
  const prevButtonRef = useRef(null);
  const nextButtonRef = useRef(null);

  const [isDownloading, setIsDownloading] = useState(false); // State to track if download is in progress
  const getApiImageUrl = () => {
    const fullUrl = allBanners[currentIndex].banner_template_image;
    const fileName = fullUrl.split("/").pop();

    // return `https://api.indiagethired.com/linkedin_banner_image?p=uploads/linkedin_banner/${fileName}`;
    return `https://api-test.xyntara.in/linkedin_banner_image?p=uploads/linkedin_banner/${fileName}`;
  };
  // const handleDownloadClick = async () => {
  //   // if (!isImageLoaded) return; // Wait for image to load
  //   if (validate()) {
  //     // Hide the buttons
  //     if (prevButtonRef.current) {
  //       prevButtonRef.current.style.display = "none";
  //     }
  //     if (nextButtonRef.current) {
  //       nextButtonRef.current.style.display = "none";
  //     }
  //     // Save the current profile state to local storage
  //     // localStorage.setItem(
  //     //   "jobseekerBannerProfile",
  //     //   JSON.stringify({
  //     //     includeName: profile.includeName,
  //     //     includeRole: profile.includeRole,
  //     //     includeEmail: profile.includeEmail,
  //     //     includePhone: profile.includePhone,
  //     //     includeWebsite: profile.includeWebsite,
  //     //     skills: profile.skills,
  //     //     locations: profile.locations,
  //     //     quotes: profile.quotes,
  //     //   })
  //     // );

  //     setIsDownloading(true); // Disable the download button

  //     try {
  //       const canvas = await html2canvas(componentRef.current, {
  //         // Add options as needed:
  //         allowTaint: true, // If necessary for cross-origin images
  //         useCORS: true, // For cross-origin images
  //         scale: 2, // Adjust scale if needed
  //       });
  //       const imgData = canvas.toDataURL("image/png");
  //       const blob = dataURItoBlob(imgData);

  //       const file_name = profile.name
  //         ? SYSTEM_PREFIX + profile.name + ".png"
  //         : SYSTEM_PREFIX + "_linked_banner.png";
  //       saveAs(blob, file_name);
  //     } catch (error) {
  //       console.error("Error capturing element:", error);
  //     } finally {
  //       // Restore the buttons
  //       if (prevButtonRef.current) {
  //         prevButtonRef.current.style.display = "block";
  //       }
  //       if (nextButtonRef.current) {
  //         nextButtonRef.current.style.display = "block";
  //       }
  //       setIsDownloading(false); // Re-enable the download button
  //     }
  //   }
  // };

  const handleDownloadClick = async () => {
    if (validate()) {
      if (prevButtonRef.current) prevButtonRef.current.style.display = "none";
      if (nextButtonRef.current) nextButtonRef.current.style.display = "none";

      setIsDownloading(true);

      const scaleWrapper = document.getElementById("jobseeker-banner-scale-wrapper");
      const originalZoom = scaleWrapper ? scaleWrapper.style.zoom : "";

      const bannerDiv = componentRef.current;
      const profileImgElement = bannerDiv ? bannerDiv.querySelector(".profile-img") : null;
      const originalProfileImgDisplay = profileImgElement ? profileImgElement.style.display : "";

      try {
        if (profileImgElement) {
          profileImgElement.style.display = "none";
        }

        if (scaleWrapper) {
          scaleWrapper.style.zoom = "1";
        }

        const originalBg = bannerDiv ? bannerDiv.style.backgroundImage : "";
        const apiUrl = getApiImageUrl();

        if (bannerDiv) {
          bannerDiv.style.backgroundImage = `url(${apiUrl})`;
          await new Promise((resolve) => {
            const img = new Image();
            img.src = apiUrl;
            if (img.complete && img.naturalWidth !== 0) {
              resolve();
            } else {
              img.onload = resolve;
              img.onerror = resolve;
            }
          });
        }

        // 🔥 Capture
        const canvas = await html2canvas(componentRef.current, {
          allowTaint: true,
          useCORS: true,
          scale: 2,
          width: 1100,
          height: 273,
          windowWidth: 1100,
          windowHeight: 273,
          scrollX: 0,
          scrollY: 0,
          ignoreElements: (element) => {
            return (
              element.classList && element.classList.contains("profile-img")
            );
          },
        });

        const imgData = canvas.toDataURL("image/png");
        const blob = dataURItoBlob(imgData);

        const file_name = profile.name
          ? SYSTEM_PREFIX + profile.name + ".png"
          : SYSTEM_PREFIX + "_linked_banner.png";

        saveAs(blob, file_name);

        if (bannerDiv && originalBg) {
          bannerDiv.style.backgroundImage = originalBg;
        }

      } catch (error) {
        console.error("Error capturing element:", error);
      } finally {
        if (profileImgElement) {
          profileImgElement.style.display = originalProfileImgDisplay;
        }
        if (scaleWrapper) {
          scaleWrapper.style.zoom = originalZoom;
        }
        if (prevButtonRef.current) prevButtonRef.current.style.display = "block";
        if (nextButtonRef.current) nextButtonRef.current.style.display = "block";
        setIsDownloading(false);
      }
    }
  };
  const dataURItoBlob = (dataURI) => {
    const byteString = atob(dataURI.split(",")[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    return new Blob([arrayBuffer], { type: "image/png" });
  };

  const handleNext = (event) => {
    event.preventDefault(); // Prevents the default form or link behavior
    setCurrentIndex((prevIndex) => (prevIndex + 1) % allBanners.length);
  };

  const handlePrevious = (event) => {
    event.preventDefault(); // Prevents the default form or link behavior
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + allBanners.length) % allBanners.length
    );
  };

  const bannerRef = useRef(null);
  const [nameFontSize, setNameFontSize] = useState(45);
  const [roleFontSize, setRoleFontSize] = useState(25);
  const [currentTemplate, setCurrentTemplate] = useState();
  // Effect to update the template when currentIndex changes
  const templates = Array.from(
    { length: 20 },
    (_, index) => `template${index + 1}`
  ); // Generates template1 to template10

  useEffect(() => {
    console.log("currentIndex", currentIndex);
    setCurrentTemplate(templates[currentIndex]);
  }, [currentIndex]);

  // Dynamic Text Adjustment Utility
  const adjustTextByCharacterLength = (
    element,
    initialFontSize,
    minFontSize,
    thresholds
  ) => {
    const textLength = element.textContent.trim().length; // Trim whitespace
    console.log("textLength", textLength);

    let fontSize = initialFontSize;

    // Iterate through thresholds to adjust font size
    for (const { threshold, reduction } of thresholds) {
      console.log("textLength", textLength, "threshold", threshold);
      if (textLength > threshold) {
        fontSize -= reduction;
      }
    }

    // Ensure the font size does not go below the minimum
    return Math.max(fontSize, minFontSize);
  };
  // Dynamic Template Font Sizes
  const getTemplateFontSizes = (template) => {
    console.log("template44", template);
    switch (template) {
      case "template1":
        return {
          name: { initial: 45, min: 20 },
          role: { initial: 25, min: 16 },
        };
      case "template2":
        return {
          name: { initial: 35, min: 20 },
          role: { initial: 20, min: 16 },
        };
      case "template3":
        return {
          name: { initial: 36, min: 20 },
          role: { initial: 20, min: 16 },
        };
      case "template9":
        return {
          name: { initial: 30, min: 20 },
          role: { initial: 16, min: 14 },
        };
      case "template10":
        return {
          name: { initial: 33, min: 20 },
          role: { initial: 16, min: 14 },
        };
      case "template11":
        return {
          name: { initial: 30, min: 20 },
          role: { initial: 16, min: 16 },
        };
      case "template12":
        return {
          name: { initial: 33, min: 20 },
          role: { initial: 16, min: 16 },
        };
      case "template13":
        return {
          name: { initial: 38, min: 20 },
          role: { initial: 18, min: 16 },
        };
      case "template14":
        return {
          name: { initial: 38, min: 20 },
          role: { initial: 16, min: 16 },
        };
      case "template15":
        return {
          name: { initial: 35, min: 20 },
          role: { initial: 16, min: 16 },
        };
      case "template16":
        return {
          name: { initial: 33, min: 20 },
          role: { initial: 16, min: 16 },
        };
      default:
        return {
          name: { initial: 40, min: 20 },
          role: { initial: 20, min: 16 },
        };
    }
  };

  useEffect(() => {
    const adjustTextLayout = () => {
      if (bannerRef.current) {
        const nameElement = bannerRef.current.querySelector(
          ".name-positions span"
        );
        const roleElement = bannerRef.current.querySelector(
          ".role-positions span"
        );
        const nameContainer =
          bannerRef.current.querySelector(".name-positions");
        const roleContainer =
          bannerRef.current.querySelector(".role-positions");

        // Get thresholds for the current template
        const templateThresholds =
          CHARACTER_THRESHOLDS[currentTemplate] ||
          CHARACTER_THRESHOLDS.template1;
        const templateFontSizes = getTemplateFontSizes(currentTemplate);

        if (nameElement && nameContainer) {
          // Adjust font size for the name
          const nameFontSize = adjustTextByCharacterLength(
            nameElement,
            templateFontSizes.name.initial,
            templateFontSizes.name.min,
            templateThresholds.name
          );

          // Update state with dynamic font size for the name
          setNameFontSize(nameFontSize);

          // Handle overflow for the name
          handleOverflow(nameElement, nameContainer, nameFontSize);
        }

        if (roleElement && roleContainer && profile.includeRole) {
          // Adjust font size for the role only if it's included
          const roleFontSize = adjustTextByCharacterLength(
            roleElement,
            templateFontSizes.role.initial,
            templateFontSizes.role.min,
            templateThresholds.role
          );

          // Update state with dynamic font size for the role
          setRoleFontSize(roleFontSize);

          // Handle overflow for the role
          handleOverflow(roleElement, roleContainer, roleFontSize);
        } else if (roleElement && roleContainer) {
          // If the role is not included, set the font size to the initial value
          setRoleFontSize(templateFontSizes.role.initial);
          roleElement.style.fontSize = `${templateFontSizes.role.initial}px`;
        }
      }
    };

    // Define the handleOverflow function
    const handleOverflow = (element, container, fontSize) => {
      element.style.fontSize = `${fontSize}px`;

      if (element.scrollWidth > container.offsetWidth * 0.95) {
        // Handle overflow if necessary
        console.log("Overflow detected for:", element);
      }
    };

    // Debounce utility
    const debounce = (func, delay) => {
      let timeoutId;
      return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => func(...args), delay);
      };
    };

    // Resize Observer Setup
    const setupResizeObserver = () => {
      if (bannerRef.current) {
        const resizeObserver = new ResizeObserver(
          debounce(() => {
            adjustTextLayout();
          }, 100)
        );

        resizeObserver.observe(bannerRef.current);
        return resizeObserver;
      }
    };

    // Initial setup
    const resizeObserver = setupResizeObserver();
    const timeoutId = setTimeout(adjustTextLayout, 200);

    // Cleanup
    return () => {
      clearTimeout(timeoutId);
      if (resizeObserver && bannerRef.current) {
        resizeObserver.unobserve(bannerRef.current);
        resizeObserver.disconnect();
      }
    };
  }, [currentIndex, currentTemplate, profile.includeName, profile.includeRole]);
  console.log("currentTemplate", currentTemplate);

  const handlePurchaseClick = () => {
    setIsLoading(true); // Step 2: Set loading state to true
    // Dispatch the action to unlock the banner
    console.log("selectedBanner234", allBanners[currentIndex].banner_id);

    dispatch(
      unlockLinkedInBannerRequest({
        banner_id: idToBase64(allBanners[currentIndex].banner_id),
      })
    );

    // Update the local state to reflect that the banner is purchased
    // setIsBannerUnlocked(true);
    allBanners[currentIndex].is_purchased = true;

    console.log("Purchase button clicked, unlocking banner");
    // You can add any additional logic here, such as showing a success message
  };

  const unlockLinkedinBannerReducerData = useSelector(
    (state) => state.unlockLinkedinBannerReducer
  );

  useEffect(() => {
    if (
      unlockLinkedinBannerReducerData.status == true &&
      unlockLinkedinBannerReducerData.message != ""
    ) {
      showToast("success", unlockLinkedinBannerReducerData.message);
      // setIsBannerUnlocked(true);
      triggerTotalPoints("buy_banner", false);

      // Update the local state to reflect that the banner is purchased
      setIsBannerUnlocked(true);
      setIsLoading(false);
      allBanners[currentIndex].is_purchased = true;
      // Dispatch action to reset the message after showing the toast
      dispatch(resetUnlockLinkedInBannerMessage());

      // setIsPurchased(true);
      // setSelectedType("FREE");
    } else if (
      unlockLinkedinBannerReducerData.status == false &&
      unlockLinkedinBannerReducerData.message != ""
    ) {
      // setIsPurchased(false);
      setIsLoading(false);
      showToast("error", unlockLinkedinBannerReducerData.message);
      // Dispatch action to reset the message after showing the toast
      dispatch(resetUnlockLinkedInBannerMessage());
    }
  }, [unlockLinkedinBannerReducerData, dispatch, allBanners, currentIndex]);

  const fetchRewardsPointsReducerData = useSelector(
    (state) => state.fetchRewardsPointsReducer
  );

  useEffect(() => {
    if (
      !fetchRewardsPointsReducerData ||
      !fetchRewardsPointsReducerData.data ||
      !Array.isArray(fetchRewardsPointsReducerData.data) ||
      fetchRewardsPointsReducerData.data.length <= 0
    ) {
      dispatch(fetchRewardsPointsRequest());
    }
  }, []);


  const buyResumePoints =
    fetchRewardsPointsReducerData?.data?.find(
      (item) => item.name === "buy_banner"
    )?.points ?? 0;

  return (
    <Modal
      isOpen={props.isOpen}
      toggle={props.toggleModal}
      centered
      className="modal-xl linkedin-banner-modal"
      backdrop="static"
      fade={false}
    // style={{ maxWidth: 968 }}
    >
      {console.log(profile)}
      <Form className="theme-form">
        <ModalHeader className="border-0" toggle={props.toggleModal}>
          AI LinkedIn Banner
        </ModalHeader>
        <ModalBody className="p-4">
          {getLinkedinBannerReducerData.isLoading ? (
            <Spinner />
          ) : (
            <div className="linked-jobseeker-banner-main">
              <div className="banner-div">
                <BannerScaleWrapper id="jobseeker-banner-scale-wrapper">
                  <div style={{ position: "relative" }}>
                    {isBannerUnlocked !== true && (
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "1100px",
                          height: "273px",
                          backgroundColor: "rgba(0, 0, 0, 0.5)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 10,
                          borderRadius: "4px",
                        }}
                      >
                        <Card
                          className="mt-2"
                          style={{ width: "380px" }}
                        >
                          <CardBody className="d-flex flex-column align-items-center">
                            <div
                              className="mb-3 mb-md-0 text-center"
                              style={{
                                width: "100%",
                                wordWrap: "break-word",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                              }}
                            >
                              <h6 style={{ fontSize: "16px", fontWeight: "bold" }}>
                                Unlock this premium banner by using{" "}
                                {showStyledCoins(allBanners[currentIndex].price)} !
                              </h6>
                            </div>
                            <div className="mt-2">
                              <Button color="warning" onClick={handlePurchaseClick}>
                                {isLoading ? "Unlocking..." : "UNLOCK THIS BANNER"}
                              </Button>
                            </div>
                          </CardBody>
                        </Card>
                      </div>
                    )}
                    <div
                      className={`banner-${allBanners[currentIndex].banner_id}`}
                      ref={componentRef}
                      style={{
                        backgroundImage: `url(${allBanners[currentIndex].banner_template_image})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "273px",
                        position: "relative", // Ensure relative positioning for absolute children
                      }}
                    >
                      <div
                        className="contact-container"
                        style={{ "--contact-bg": "#402871" }}
                      >
                        {profile.includePhone &&
                          allBanners[currentIndex].phone_allowed != 0 &&
                          profile.phone && profile.phone.trim() !== "" && ( //Added by Aman Maurya
                            <div className="contact-item phone">
                              <span>
                                <FaPhoneAlt size={18} />
                              </span>{" "}
                              {profile.phone}
                            </div>
                          )}
                        {profile.includeEmail &&
                          allBanners[currentIndex].email_allowed != 0 && (
                            <div className="contact-item email">
                              <span>
                                {" "}
                                <MdEmail />{" "}
                              </span>
                              {profile.email}
                            </div>
                          )}
                        {profile.locations?.length > 0 &&
                          allBanners[currentIndex].locations_allowed != 0 && (
                            <div className="contact-item email">
                              <span>
                                {" "}
                                <TiLocation />
                              </span>

                              {profile.locations
                                .slice(0, 2) // Limit to the allowed number of locations
                                .map((location, index, array) => (
                                  <React.Fragment key={index}>
                                    {location.label}
                                    {index < array.length - 1 && ", "}{" "}
                                    {/* Add comma except after the last item */}
                                  </React.Fragment>
                                ))}
                            </div>
                          )}
                      </div>

                      <div className="quotes-positions">
                        {profile.quotes &&
                          allBanners[currentIndex].default_quotes &&
                          profile.quotes
                            .split(",")
                            .map((quotes, index) => (
                              <li key={index}>{quotes.trim()}</li>
                            ))}
                      </div>
                      <div className="profile-banner" ref={bannerRef}>
                        {/* Name Section */}

                        <div
                          className="name-positions"
                          style={{
                            fontSize: `${nameFontSize}px`,
                          }}
                        >
                          {profile.includeName &&
                            allBanners[currentIndex].name_allowed != 0 && (
                              <span>{profile.name}</span>
                            )}
                        </div>

                        {/* Role Section */}
                        <div
                          className="role-positions"
                          style={{
                            fontSize: `${roleFontSize}px`,
                          }}
                        >
                          {profile.includeRole &&
                            allBanners[currentIndex].role_allowed != 0 && (
                              <span>{profile.jobseeker_preferred_job_title}</span>
                            )}
                        </div>
                      </div>

                      <div
                        className="skills-positions"
                        style={{ "--skills-bg": "#f9fef9" }}
                        ref={skillsContainerRef}
                      >
                        <ul>
                          {profile.skills &&
                            allBanners[currentIndex].skills_allowed != 0 &&
                            profile.skills
                              // .slice(0, allBanners[currentIndex].skills_allowed) // Limit to the allowed number of skills
                              .map((skill, index) => (
                                <li key={index}>{skill.label}</li> // Use skill.label to display the skill name
                              ))}
                        </ul>
                      </div>

                      <div
                        className="slider-controls"
                        ref={componentPreRef}
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          pointerEvents: "none", // allow clicks only on buttons
                          zIndex: 100,
                        }}
                      >
                        <button
                          onClick={handlePrevious}
                          ref={prevButtonRef}
                          className="prev-btn"
                          style={{
                            position: "absolute",
                            top: "50%",
                            left: "16px",
                            transform: "translateY(-50%)",
                            zIndex: 101,
                            border: "none",
                            borderRadius: "50%",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            cursor: "pointer",
                            pointerEvents: "auto",
                          }}
                        >
                          <IoIosArrowBack size={24} />
                        </button>
                        <button
                          onClick={handleNext}
                          ref={nextButtonRef}
                          className="next-btn"
                          style={{
                            position: "absolute",
                            top: "50%",
                            right: "16px",
                            transform: "translateY(-50%)",
                            zIndex: 101,
                            border: "none",
                            borderRadius: "50%",
                            width: "40px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                            cursor: "pointer",
                            pointerEvents: "auto",
                          }}
                        >
                          <IoIosArrowForward size={24} />
                        </button>
                      </div>

                      <div className="powerby-img d-flex justify-content-center align-items-center">
                        <img
                          src="/job/naukrify_poweredby.png"
                          // src="https://dev.naukrify.com/job/naukrify_poweredby.png"
                          alt="User profile picture"
                          className="img-fluid"
                        />
                      </div>
                      <div className="profile-img bg-white rounded-circle d-flex justify-content-center align-items-center">
                        <img
                          style={{ zIndex: 1 }}
                          src={profile.photo}
                          alt="User profile picture"
                          className="rounded-circle img-fluid"
                        />
                      </div>
                    </div>
                  </div>
                </BannerScaleWrapper>
              </div>
            </div>
          )}
          <Row className=" mt-4">
            <Col md={8}>
              <h4 className="name mt-3 text-uppercase">
                {profile.name && capitalize(profile.name)}
              </h4>
              <div className="about">
                <p className="resume_headline">
                  {profile.resume_headline && (
                    <>
                      {profile.resume_headline
                        ? capitalize(profile.resume_headline)
                        : ""}
                    </>
                  )}
                </p>
              </div>
            </Col>
            <Col md={4}>
              <div className="company mt-3">
                {profile.organization && profile.organization.length > 0 && (
                  <div className="d-flex align-items-center mb-2">
                    <div
                      className="d-flex justify-content-center align-items-center bg-secondary text-white me-2"
                      style={{
                        width: "25px",
                        height: "25px",
                        fontSize: "16px",
                        flexShrink: 0, // Prevent the icon from shrinking
                      }}
                    >
                      <TbBuilding />
                    </div>

                    <span style={{ wordBreak: "break-word", whiteSpace: "normal" }}>{profile.organization[0].label}</span>
                  </div>
                )}

                {profile.education && profile.education.length > 0 && (
                  <div className="d-flex align-items-center">
                    <div
                      className="d-flex justify-content-center align-items-center bg-secondary text-white me-2"
                      style={{
                        width: "25px",
                        height: "25px",
                        fontSize: "16px",
                        flexShrink: 0, // Prevent the icon from shrinking
                      }}
                    >
                      <FaGraduationCap />
                    </div>

                    <span style={{ wordBreak: "break-word", whiteSpace: "normal" }} >
                      {
                        profile.education[profile.education.length - 1]
                          .jobseeker_college_name
                      }
                    </span>
                  </div>
                )}
                {(!profile.organization || profile.organization.length === 0) &&
                  (!profile.education || profile.education.length === 0) && (
                    <div
                      className="d-flex justify-content-center align-items-center bg-white text-black me-2"
                      style={{
                        width: "100%",
                        height: "30px",
                        fontSize: "14px",
                        filter: "blur(3px)",
                      }}
                    >
                      Company Name
                    </div>
                  )}
              </div>
            </Col>
          </Row>
          <Row className="mt-3">
            <Col md={12}>
              <FormGroup>
                {allBanners[currentIndex].name_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includeName"
                      name="includeName"
                      checked={profile.includeName}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includeName">Add Name</Label>
                  </>
                )}
                {allBanners[currentIndex].role_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includeRole"
                      name="includeRole"
                      checked={profile.includeRole}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includeRole">Add Role</Label>
                  </>
                )}
                {allBanners[currentIndex].phone_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includePhone"
                      name="includePhone"
                      checked={profile.includePhone}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includePhone">Add Phone</Label>
                  </>
                )}
                {allBanners[currentIndex].email_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includeEmail"
                      name="includeEmail"
                      checked={profile.includeEmail}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includeEmail">Add Email</Label>
                  </>
                )}
                {allBanners[currentIndex].website_allowed != 0 && (
                  <>
                    <Input
                      className="checkbox_animated ms-2"
                      type="checkbox"
                      id="includeWebsite"
                      name="includeWebsite"
                      checked={profile.includeWebsite}
                      onChange={handleCheckboxChange}
                    />
                    <Label for="includeWebsite">Add Website</Label>
                  </>
                )}
              </FormGroup>
            </Col>
            {allBanners[currentIndex].default_quotes && (
              <Col md={6}>
                <FormGroup>
                  <Label for="quotes">Quotes</Label>
                  <Input
                    className="form-control form-control-sm"
                    type="text"
                    id="quotes"
                    name="quotes"
                    value={profile.quotes}
                    onChange={handleChange}
                    placeholder="Enter quotes"
                  />
                </FormGroup>
              </Col>
            )}

            {allBanners[currentIndex].skills_allowed != 0 && (
              <Col md={6}>
                <FormGroup>
                  <Label for="skills">Skills</Label>
                  <Select
                    isMulti
                    options={mandatorySkillsOptions}
                    isLoading={mandatorySkillsReducerData.mandatoryLoading}
                    value={profile.skills} // Use formData.skills directly
                    onChange={handleMandatorySkillsChange} // Handle change event
                    styles={customOptionsStyle}
                    placeholder={"Select Technology..."}
                    onFocus={handlemandatorySkillsFocus} // Handle focus event
                    onInputChange={handleMandatorySkillsInputChange}
                  />
                  {errors && (
                    <div className="text-danger mt-2">{errors.skills}</div>
                  )}
                  <small className="form-text" style={{ color: 'red' }}>
                    Add your skills here. If the list becomes too long, excess
                    skills will be hidden automatically to maintain a clean
                    display.
                  </small>
                </FormGroup>
              </Col>
            )}
            {allBanners[currentIndex].locations_allowed != 0 && (
              <Col md="6">
                <FormGroup>
                  <Label>Job Location(s)</Label>
                  <Select
                    isMulti
                    options={locationOptions}
                    isLoading={locationReducerData.isLoading}
                    placeholder="Select locations..."
                    value={profile.locations}
                    onChange={handleLocationsChange}
                    onInputChange={handleLocationInputChange}
                    styles={customOptionsStyle}
                    onFocus={handleLocationFocus}
                  />
                  {errors && (
                    <div className="text-danger mt-2">{errors.locations}</div>
                  )}
                  <small className="form-text" style={{ color: 'red' }}>
                    Add your loaction here. If the list becomes too long, excess
                    location will be hidden automatically to maintain a clean
                    display.
                  </small>
                </FormGroup>
              </Col>
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          {isBannerUnlocked == true && (
            <Button
              type="button"
              color="secondary"
              disabled={isDownloading} // Disable the button when downloading
              onClick={handleDownloadClick}
            >
              {isDownloading ? "Downloading..." : "Download"}
            </Button>
          )}
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default BannerModal;
